import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { SavedPartListsStore } from 'cart-data';
import { ConfirmDialogResponse, DialogService, LoadingSkeletonDirective2, NoteComponent } from 'common-ui';
import { ErrorComponent } from 'error-ui';

@Component({
  selector: 'ideal-saved-parts-list-list',
  imports: [
    MatListModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    LoadingSkeletonDirective2,
    ErrorComponent,
    NoteComponent,
    JsonPipe,
  ],
  templateUrl: './saved-parts-list-list.component.html',
  styleUrl: './saved-parts-list-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [SavedPartListsStore],
})
export class SavedPartsListListComponent {
  private readonly _dialogService = inject(DialogService);
  private readonly savedPartListsStore = inject(SavedPartListsStore);

  protected readonly savedPartLists = this.savedPartListsStore.savedPartLists;
  protected readonly savedPartListsLoading = this.savedPartListsStore.savedPartListsLoading;
  protected readonly savedPartListsError = this.savedPartListsStore.savedPartListsError;

  protected async deletePartList(partList: { id: string; name: string }) {
    const result = await this._dialogService.confirm(
      `Are you sure you want to delete the saved part list "${partList.name}"?`,
      'Delete Part List',
      {
        negativeButtonHidden: true,
        positiveButtonLabel: 'Delete',
        positiveButtonWarn: true,
      },
    );
    if (result === ConfirmDialogResponse.Positive) {
      await this.savedPartListsStore.deleteSavedList(partList.id);
    }
  }
}
